// @owners { team: patients-team }

export const FETCH_APPLE_PAY_SUPPORT_SUCCEEDED = 'FETCH_APPLE_PAY_SUPPORT_SUCCEEDED';

export type ActionFetchApplePaySupportSucceeded = {
  type: typeof FETCH_APPLE_PAY_SUPPORT_SUCCEEDED;
  payload: boolean;
};
export function fetchApplePaySupportSucceeded(isApplePaySupported: boolean): ActionFetchApplePaySupportSucceeded {
  return {
    type: FETCH_APPLE_PAY_SUPPORT_SUCCEEDED,
    payload: isApplePaySupported,
  };
}

// eslint-disable-next-line sonarjs/redundant-type-aliases -- domain-named union type; will gain more members as Apple Pay actions are added
export type ApplePayActions = ActionFetchApplePaySupportSucceeded;
